(function (document, $) {
  'use strict';

  // Local scripts
  require('./components/site/menu-toggle');
  require('./components/site/usp-rotator');
  require('./components/site/search-course');
  require('./components/site/schedule');
  require('./components/site/gmaps-map');
  require('./components/site/enroll-together');
  require('./components/user/profile-billing-toggle');
  require('./components/confirm');
  require('./components/site/table-divider');
  require('./components/site/search-widget');
  require('./components/site/truncate-text');
  require('./components/site/time-difference');
  require('./components/site/wrapper-padding');
  require('./components/collapsible-section');
  require('./components/site/datepicker');
  require('./components/site/course-wizard');

  // Youtube player init
  var ytPlayer = require('./components/youtube-player');
  window.onYouTubeIframeAPIReady = ytPlayer.init;

  // stuff too small to include
  if ($('.star-rating').length > 0) {
    $('.star-rating').each(function () {
      var percentage = parseFloat($(this).data('rating')) * 20;
      var meterWidth = ($(this).innerWidth() - 2 ) * (percentage / 100);
      $(this)
        .find('.meter')
        .css('width', meterWidth);
    });
  }

  if ($('.scroll-down').length > 0) {
    $('.scroll-down').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $('.c-hero')
            .next()
            .offset().top
        },
        300
      );
    });
  }

  if ($('.search-bar').length) {
    $('.search-bar').on('submit', function (e) {
      var $form = $(this);
      var root = $form.find('.field-root').val();
      var online = $('[name="is-online"]').val();
      var course = $form.find('.field-course').val();
      var loc = $form.find('.field-location').val();
      e.preventDefault();
      
      if ($(this).hasClass('for-alternatives') && online === 'false') {
        location = '?course=' + course + '&city=' + loc;
      } else if ($(this).hasClass('for-alternatives') && online === 'true') {
        location = '?course=' + course + '&online=true';
      } else if (root && course && loc) {
        location = root + course + '/' + loc;
      } else if (root && loc) {
        location = root + 'spaans-in-' + loc;
      } else if (root && course && online === 'true') {
        location = root + course + '/online';
      }
    });

    $('.js-search-toggle').on('click', function () {
      $('.search-wrapper').toggleClass('is-open');
      $('.search-toggle').toggleClass('is-open');
      $(this).toggleClass('arrow-reversed');
    });
  }

  /* sticky search widget */
  const searchWidget = document.querySelector('[data-module="search-widget"]:not(.no-stick)');

  if (searchWidget) {
    function toggleStickySearchWidget() {
      let widgetBottom;
      const nextElement = searchWidget.previousElementSibling;

      widgetBottom = nextElement.getBoundingClientRect().top - parseFloat(getComputedStyle(searchWidget).marginBottom);
      searchWidget.classList[widgetBottom < 40 ? 'add' : 'remove']('sticky');
    }

    toggleStickySearchWidget();
    window.addEventListener('resize', toggleStickySearchWidget)
    window.addEventListener('scroll', toggleStickySearchWidget)
  }


  function isOnlineCheck() {
    const locationSelector = document.querySelector('[name="location"]');
    if (!locationSelector) return;
    const form = document.querySelector('[data-module="search-widget"]');
    const isOnlineValue = $('[name="is-online"]').val();
    const isOnline = isOnlineValue === 'true' || isOnlineValue === '';

    $('.location-container').attr('hidden', isOnline);
    locationSelector.required = !isOnline;
    if (isOnline) locationSelector.value = '';
    form.classList[isOnline ? 'add' : 'remove']('search-bar--online');
    form.classList[isOnline ? 'remove' : 'add']('search-bar--offline');
  }

  $('[name="is-online"]').on('change', isOnlineCheck);
  setTimeout(isOnlineCheck, 10);

  if ($('.almost-full').length) {
    $('*:not(.almost-full.icon)').on('click mouseover focus', function () {
      $('.almost-full.icon').blur();
    });
  }

  if ($('[data-js-bind="payment-option"]').length) {
    var $bankSelect = $('[data-js-bind="payment-issuer"]');
    var $selectRow = $bankSelect.closest('.form-group');

    $('.payment-selection__button').on('click', function () {
      if ($(this).hasClass('payment-selection__button--ideal')) {
        $bankSelect.attr('required', 'required');
        $selectRow.slideDown();
      } else {
        $bankSelect.removeAttr('required');
        $selectRow.slideUp();
      }
    });
  }

  // read more tweaks
  if ($('#read-more-checkbox').length) {
    var firstTitle = $('main h2').first()[0];

    $('#read-more-checkbox').on('change', function () {
      if (!$(this)[0].checked) {
        var titleBB = firstTitle.getBoundingClientRect();
        if (titleBB.top < titleBB.height) {
          firstTitle.scrollIntoView();
        }
      }
    });
  }

  const locationInfoToggle = document.getElementById('more-info__input');
  if (locationInfoToggle) {
    locationInfoToggle.addEventListener('change', function () {
      if (locationInfoToggle.checked && typeof window.initMap === 'function' && typeof locationInfoToggle.dataset.init !== 'undefined') {
        window.initMap();
        locationInfoToggle.removeAttribute('data-init');
      }
    });
  }

  $('.copy').on('click', function () {
    this.focus();
    this.select();
    document.execCommand('copy');
    $('.copy-success').removeAttr('hidden');
  })

  setTimeout(() => {
    $('.js-popup').css({'display': 'block'});
  }, 5000);

  $('.js-close').on('click', (e) => {
    window.sessionStorage.setItem(e.currentTarget.id, "closed");
    $('.notification-container').css('display', 'none');
  });

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

})(document, jQuery);
